import { TFunction } from 'core/i18n/i18n';
import { ExtendedValidationMessages } from 'commons/components';

export const getNameValidationMessages = (t: TFunction): ExtendedValidationMessages => ({
    error: {
        'value-missing': t('settings.system.custom-fields.fields.modal.create.name.error.value-missing'),
        'too-long': t('settings.system.custom-fields.fields.modal.create.name.error.too-long'),
        duplicated: t('settings.system.custom-fields.fields.modal.create.name.error.duplicated'),
        size: t('settings.system.custom-fields.fields.modal.create.name.error.too-long'), // Same as 'too-long'
    },
});
